<div
  class="radio-button-container"
  (click)="buttonClick.emit()"
  [class]="{
    'radio-button-large': size() === InputSize.large,
    'radio-button-small': size() === InputSize.small,
    'radio-button-disabled': disabled(),
    'radio-button-selected': selected(),
  }">
  <div class="radio-icon-outer">
    <div class="radio-icon-inner">&nbsp;</div>
  </div>
  <ng-content></ng-content>
</div>
